/**
 * @param {ApplicationSchedule} form
 * @returns {ApplicationSchedule}
 */
export function initApplicationSchedule(form = {}) {
    return {
        ...(form || {}),

        _id: form?._id,

        round: form?.round ?? null,
        shows: form?.shows ?? true,
        stops: form?.stops ?? false,
        openAt: form?.openAt || null,
        deadAt: form?.deadAt || null,

        message: form?.message,
    };
}

/**
 * @typedef {object} ApplicationSchedule
 *
 * @property {string} _id
 * @property {number} round
 * @property {boolean} shows
 * @property {boolean} stops
 * @property {string} openAt
 * @property {string} deadAt
 *
 * @property {object} [message]
 * @property {string} message.beforeOpen
 * @property {string} message.dead
 * @property {string} message.dead2
 * @property {string} message.stop
 */
